import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { MaterialModule } from "../../../../modules/material/material.module";
import { TranslateModule } from "@ngx-translate/core";

import { ColorPickerModule } from "../../../shared/components/colorPicker/color-picker.module";

import { SaysoColorPickerComponent } from "./sayso-color-picker.component";

@NgModule({
  imports: [CommonModule, FormsModule, MaterialModule, TranslateModule, ColorPickerModule],
  declarations: [SaysoColorPickerComponent],
  exports: [SaysoColorPickerComponent]
})
export class SaysoColorPickerModule {}
